module.exports = __webpack_public_path__ + "static/media/objects_26.89826885.svg";